import { render } from 'inferno';
import App from './App/App';
import './index.css';

render(<App />, document.getElementById('app'));



// WEBPACK FOOTER //
// ./src/index.js